import { useState } from "react";
import { Link } from "react-router-dom";
import "./Privacy_policy.css";
import { useEffect } from "react";
import { FaChevronUp } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
const Privacy_policy = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    const policyContenhi =[
        {
          "title": "हम कौन सी जानकारी एकत्र करते हैं",
          "content": [
            "हम निम्नलिखित प्रकार की जानकारी एकत्र करते हैं:",
            "व्यक्तिगत जानकारी: नाम, ईमेल पता, फोन नंबर, शिपिंग और बिलिंग पता, खाता विवरण (यूज़रनेम, पासवर्ड)।",
            "भुगतान जानकारी: क्रेडिट/डेबिट कार्ड विवरण, यूपीआई आईडी, जो सुरक्षित रूप से तृतीय-पक्ष भुगतान गेटवे द्वारा प्रोसेस की जाती हैं।",
            "गैर-व्यक्तिगत जानकारी: आईपी पता, ब्राउज़र प्रकार, ऑपरेटिंग सिस्टम, डिवाइस विवरण।",
            "कुकीज़ और ट्रैकिंग: कुकीज़, वेब बीकन, या अन्य ट्रैकिंग तकनीकों के माध्यम से एकत्रित जानकारी।"
          ]
        },
        {
          "title": "हम आपकी जानकारी का उपयोग कैसे करते हैं",
          "content": [
            "आपके ऑर्डर को प्रोसेस और डिलीवर करने के लिए।",
            "ग्राहक सहायता प्रदान करने के लिए।",
            "यूज़र अनुभव को बेहतर बनाने और हमारी वेबसाइट को सुधारने के लिए।",
            "प्रोमोशनल ऑफ़र, अपडेट और मार्केटिंग संचार भेजने के लिए (आपकी सहमति के साथ)।",
            "कानूनी और नियामक दायित्वों का अनुपालन सुनिश्चित करने के लिए।"
          ]
        },
        {
          "title": "आपकी जानकारी साझा करना",
          "content": [
            "तृतीय-पक्ष सेवा प्रदाता: भुगतान प्रोसेसिंग, लॉजिस्टिक्स और एनालिटिक्स के लिए।",
            "कानूनी अधिकारी: जब कानून द्वारा आवश्यक हो या कानूनी अनुरोधों के जवाब में।",
            "व्यावसायिक हस्तांतरण: विलय, अधिग्रहण, या परिसंपत्तियों की बिक्री की स्थिति में।"
          ]
        },
        {
          "title": "कुकीज़ और ट्रैकिंग तकनीक",
          "content": [
            "आपकी प्राथमिकताओं को याद रखने के लिए।",
            "वेबसाइट ऑप्टिमाइज़ेशन के लिए यूज़र व्यवहार को ट्रैक और विश्लेषण करने के लिए।",
            "व्यक्तिगत सिफारिशें प्रदान करने के लिए।",
            "आप अपने ब्राउज़र सेटिंग्स में अपनी कुकी प्राथमिकताओं को प्रबंधित कर सकते हैं।"
          ]
        },
        {
          "title": "सुरक्षा उपाय",
          "content": [
            "भुगतान लेनदेन के लिए सिक्योर सॉकेट लेयर (SSL) एन्क्रिप्शन।",
            "नियमित सुरक्षा ऑडिट और अपडेट।"
          ]
        },
        {
          "title": "डेटा संग्रहण",
          "content": [
            "हम आपकी व्यक्तिगत जानकारी को तब तक रखते हैं जब तक कि यह उल्लिखित उद्देश्यों को पूरा करने के लिए आवश्यक हो।",
            "कानूनी और नियामक दायित्वों का पालन करने के लिए।"
          ]
        },
        {
          "title": "आपके अधिकार",
          "content": [
            "पहुँच और सुधार: अपनी व्यक्तिगत जानकारी को एक्सेस करने या सही करने का अनुरोध करें।",
            "सहमति वापस लें: मार्केटिंग संचार से बाहर निकलें।",
            "अपना डेटा हटाएं: कानूनी और परिचालन सीमाओं के अधीन अपने डेटा को हटाने का अनुरोध करें।"
          ]
        },
        {
          "title": "तृतीय-पक्ष लिंक",
          "content": [
            "हमारी वेबसाइट में बाहरी वेबसाइटों के लिंक हो सकते हैं। हम उनकी गोपनीयता नीतियों या सामग्री के लिए जिम्मेदार नहीं हैं।"
          ]
        },
        {
          "title": "इस गोपनीयता नीति में परिवर्तन",
          "content": [
            "हम समय-समय पर इस गोपनीयता नीति को अपडेट कर सकते हैं। परिवर्तन इस पृष्ठ पर संशोधित तिथि के साथ पोस्ट किए जाएंगे।"
          ]
        },
        {
          "title": "हमसे संपर्क करें",
          "content": [
            "ईमेल: Support@terraclenz.com",
            "फोन: 7022519222"
          ]
        }
      ];
    const policyContente = [
        {
            title: "Information We Collect",
            content: (
                <>
                    <p>We collect the following types of information:</p>
                    <ul>
                        <li><strong>Personal Information:</strong> Name, email address, phone number, shipping and billing addresses, account details (username, password).</li>
                        <li><strong>Payment Information:</strong> Credit/debit card details, UPI IDs, securely processed by third-party payment gateways.</li>
                        <li><strong>Non-Personal Information:</strong> IP address, browser type, operating system, device details.</li>
                        <li><strong>Cookies & Tracking:</strong> Information collected through cookies, web beacons, or other tracking technologies.</li>
                    </ul>
                </>
            ),
        },
        {
            title: "How We Use Your Information",
            content: (
                <ul>
                    <li>Process and deliver your orders.</li>
                    <li>Provide customer support.</li>
                    <li>Enhance user experience and improve our website.</li>
                    <li>Send promotional offers, updates, and marketing communications (with consent).</li>
                    <li>Ensure compliance with legal and regulatory obligations.</li>
                </ul>
            ),
        },
        {
            title: "Sharing Your Information",
            content: (
                <ul>
                    <li>Third-Party Service Providers: For payment processing, logistics, and analytics.</li>
                    <li>Legal Authorities: When required by law or in response to legal requests.</li>
                    <li>Business Transfers: In the event of a merger, acquisition, or sale of assets.</li>
                </ul>
            ),
        },
        {
            title: "Cookies and Tracking Technologies",
            content: (
                <ul>
                    <li>Remember your preferences.</li>
                    <li>Track and analyze user behavior for website optimization.</li>
                    <li>Provide personalized recommendations.</li>
                    <li>You can manage your cookie preferences in your browser settings.</li>
                </ul>
            ),
        },
        {
            title: "Security Measures",
            content: (
                <ul>
                    <li>Secure Socket Layer (SSL) encryption for payment transactions.</li>
                    <li>Regular security audits and updates.</li>
                </ul>
            ),
        },
        {
            title: "Data Retention",
            content: (
                <ul>
                    <li>We retain your personal information as long as necessary for fulfilling outlined purposes.</li>
                    <li>Complying with legal and regulatory obligations.</li>
                </ul>
            ),
        },
        {
            title: "Your Rights",
            content: (
                <ul>
                    <li>Access and Correction: Request access to or correction of your personal data.</li>
                    <li>Withdraw Consent: Opt out of marketing communications.</li>
                    <li>Delete Your Data: Request deletion of your data, subject to legal and operational constraints.</li>
                </ul>
            ),
        },
        {
            title: "Third-Party Links",
            content: <p>Our website may contain links to external websites. We are not responsible for their privacy practices or content.</p>,
        },
        {
            title: "Changes to This Privacy Policy",
            content: <p>We may update this Privacy Policy periodically. Changes will be posted on this page with the updated revision date.</p>,
        },
        {
            title: "Contact Us",
            content: (
                <>
                    <p>Email: Support@terraclenz.com</p>
                    <p>Phone: 7022519222</p>
                </>
            ),
        },
    ];
    const policyContentte = [
        {
            title: "మేము ఏ సమాచారాన్ని సేకరిస్తాము",
            content: (
                <>
                    <p>మేము కింది రకాల సమాచారాన్ని సేకరిస్తాము:</p>
                    <ul>
                        <li><strong>వ్యక్తిగత సమాచారం:</strong> పేరు, ఇమెయిల్ చిరునామా, ఫోన్ నంబర్, షిప్పింగ్ మరియు బిల్లింగ్ చిరునామాలు, ఖాతా వివరాలు (వినియోగదారు పేరు, పాస్‌వర్డ్).</li>
                        <li><strong>చెల్లింపు సమాచారం:</strong> క్రెడిట్/డెబిట్ కార్డు వివరాలు, UPI IDలు, మూడవ-పక్ష చెల్లింపు గేట్వేలు ద్వారా సురక్షితంగా ప్రాసెస్ చేయబడతాయి.</li>
                        <li><strong>వ్యక్తిగతేతర సమాచారం:</strong> IP చిరునామా, బ్రౌజర్ రకం, ఆపరేటింగ్ సిస్టమ్, పరికర వివరాలు.</li>
                        <li><strong>కుకీలు & ట్రాకింగ్:</strong> కుకీలు, వెబ్ బీకాన్లు లేదా ఇతర ట్రాకింగ్ సాంకేతికతల ద్వారా సేకరించిన సమాచారం.</li>
                    </ul>
                </>
            ),
        },
        {
            title: "మేము మీ సమాచారాన్ని ఎలా ఉపయోగిస్తాము",
            content: (
                <ul>
                    <li>మీ ఆర్డర్‌లను ప్రాసెస్ చేసి డెలివరీ చేయడం.</li>
                    <li>కస్టమర్ సపోర్ట్ అందించడం.</li>
                    <li>వినియోగదారు అనుభవాన్ని మెరుగుపరచడం మరియు మా వెబ్‌సైట్‌ను అభివృద్ధి చేయడం.</li>
                    <li>ప్రచార ఆఫర్‌లు, నవీకరణలు, మరియు మార్కెటింగ్ కమ్యూనికేషన్లు పంపడం (మీ అనుమతితో).</li>
                    <li>చట్టపరమైన మరియు నియంత్రణా బాధ్యతల్ని పాటించడం.</li>
                </ul>
            ),
        },
        {
            title: "మీ సమాచారం ఎవరికీ పంచుతాము",
            content: (
                <ul>
                    <li>మూడవ-పక్ష సేవా ప్రదాతలు: చెల్లింపు ప్రాసెసింగ్, లాజిస్టిక్స్, మరియు విశ్లేషణల కోసం.</li>
                    <li>చట్టపరమైన అధికారాలు: చట్టపరమైన అవసరాలకు లేదా న్యాయ అభ్యర్థనలకు ప్రతిస్పందనగా.</li>
                    <li>వ్యాపార బదిలీలు: విలీనాలు, స్వాధీనం, లేదా ఆస్తుల అమ్మకాల్లో.</li>
                </ul>
            ),
        },
        {
            title: "కుకీలు మరియు ట్రాకింగ్ టెక్నాలజీలు",
            content: (
                <ul>
                    <li>మీ ప్రాధాన్యతలను గుర్తుంచుకోవడం.</li>
                    <li>వినియోగదారుల ప్రవర్తనను ట్రాక్ చేసి వెబ్‌సైట్ ఆప్టిమైజేషన్ చేయడం.</li>
                    <li>వ్యక్తిగతమైన సిఫార్సులను అందించడం.</li>
                    <li>మీరు మీ కుకీ ప్రాధాన్యతలను మీ బ్రౌజర్ సెట్టింగ్‌లలో నిర్వహించవచ్చు.</li>
                </ul>
            ),
        },
        {
            title: "భద్రతా చర్యలు",
            content: (
                <ul>
                    <li>చెల్లింపు లావాదేవీల కోసం సెక్యూర్ సాకెట్ లేయర్ (SSL) ఎన్‌క్రిప్షన్.</li>
                    <li>నియమిత భద్రతా తనిఖీలు మరియు నవీకరణలు.</li>
                </ul>
            ),
        },
        {
            title: "సమాచార నిల్వ (డేటా రిటెన్షన్)",
            content: (
                <ul>
                    <li>మేము మీ వ్యక్తిగత సమాచారాన్ని అవసరమైనంత కాలం పాటు నిల్వ ఉంచుతాము.</li>
                    <li>చట్టపరమైన మరియు నియంత్రణా బాధ్యతల కోసం నిల్వ ఉంచడం.</li>
                </ul>
            ),
        },
        {
            title: "మీ హక్కులు",
            content: (
                <ul>
                    <li>ప్రవేశం మరియు సరిచేయడం: మీ వ్యక్తిగత డేటాను పొందడానికి లేదా సరిచేయడానికి అభ్యర్థించండి.</li>
                    <li>అనుమతి ఉపసంహరణ: మార్కెటింగ్ కమ్యూనికేషన్‌ల నుండి తప్పించుకోవచ్చు.</li>
                    <li>మీ డేటాను తొలగించండి: చట్టపరమైన మరియు కార్యకలాప పరిమితులకు లోబడి మీ డేటా తొలగించవచ్చు.</li>
                </ul>
            ),
        },
        {
            title: "మూడవ-పక్ష లింకులు",
            content: <p>మా వెబ్‌సైట్‌లో బాహ్య వెబ్‌సైట్‌లకు లింక్‌లు ఉండవచ్చు. వాటి గోప్యతా విధానాలకు లేదా కంటెంట్‌కు మేము బాధ్యులు కాదు.</p>,
        },
        {
            title: "ఈ గోప్యతా విధానంలో మార్పులు",
            content: <p>మేము ఈ గోప్యతా విధానాన్ని కాలానుగుణంగా నవీకరించవచ్చు. మార్పులను ఈ పేజీలో అప్డేట్ చేసిన తేదీతో ప్రచురిస్తాము.</p>,
        },
        {
            title: "మమ్మల్ని సంప్రదించండి",
            content: (
                <>
                    <p>ఇమెయిల్: Support@terraclenz.com</p>
                    <p>ఫోన్: 7022519222</p>
                </>
            ),
        },
    ];

    const policyContentka = [
    {
        title: "ನಾವು ಸಂಗ್ರಹಿಸುವ ಮಾಹಿತಿ",
        content: (
            <>
                <p>ನಾವು ಈ ಕೆಳಗಿನ ರೀತಿಯ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸುತ್ತೇವೆ:</p>
                <ul>
                    <li><strong>ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ:</strong> ಹೆಸರು, ಇಮೇಲ್ ವಿಳಾಸ, ದೂರವಾಣಿ ಸಂಖ್ಯೆ, ಸಾಗಣೆ ಮತ್ತು ಬಿಲ್ಲಿಂಗ್ ವಿಳಾಸಗಳು, ಖಾತೆ ವಿವರಗಳು (ಬಳಕೆದಾರ ಹೆಸರು, ಪಾಸ್ವರ್ಡ್).</li>
                    <li><strong>ಪಾವತಿ ಮಾಹಿತಿ:</strong> ಕ್ರೆಡಿಟ್/ಡೆಬಿಟ್ ಕಾರ್ಡ್ ವಿವರಗಳು, UPI ಐಡಿಗಳು, ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಪಾವತಿ ದ್ವಾರಗಳಿಂದ ಸುರಕ್ಷಿತವಾಗಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ.</li>
                    <li><strong>ವೈಯಕ್ತಿಕವಲ್ಲದ ಮಾಹಿತಿ:</strong> IP ವಿಳಾಸ, ಬ್ರೌಸರ್ ಪ್ರಕಾರ, ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್, ಸಾಧನದ ವಿವರಗಳು.</li>
                    <li><strong>ಕುಕೀಸ್ & ಟ್ರಾಕಿಂಗ್:</strong> ಕುಕೀಸ್, ವೆಬ್ ಬೀಕನ್‌ಗಳು ಅಥವಾ ಇತರ ಟ್ರಾಕಿಂಗ್ ತಂತ್ರಜ್ಞಾನಗಳ ಮೂಲಕ ಸಂಗ್ರಹಿಸಲಾದ ಮಾಹಿತಿ.</li>
                </ul>
            </>
        ),
    },
    {
        title: "ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ನಾವು ಹೇಗೆ ಬಳಸುತ್ತೇವೆ",
        content: (
            <ul>
                <li>ನಿಮ್ಮ ಆದೇಶಗಳನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಿ ಮತ್ತು ತಲುಪಿಸಿ.</li>
                <li>ಗ್ರಾಹಕ ಬೆಂಬಲ ಒದಗಿಸುವುದು.</li>
                <li>ಬಳಕೆದಾರರ ಅನುಭವವನ್ನು ಸುಧಾರಿಸಿ ಮತ್ತು ನಮ್ಮ ಜಾಲತಾಣವನ್ನು ಉತ್ತಮಗೊಳಿಸಿ.</li>
                <li>ಪ್ರಚಾರದ ಕೊಡುಗೆಗಳು, ನವೀಕರಣಗಳು ಮತ್ತು ಮಾರ್ಕೆಟಿಂಗ್ ಸಂವಹನಗಳನ್ನು (ಸಮ್ಮತಿಯೊಂದಿಗೆ) ಕಳುಹಿಸಿ.</li>
                <li>ಕಾನೂನು ಮತ್ತು ನಿಬಂಧನೆಗಳ ಜವಾಬ್ದಾರಿಗಳನ್ನು ಪಾಲಿಸುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.</li>
            </ul>
        ),
    },
    {
        title: "ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ಹಂಚಿಕೊಳ್ಳುವುದು",
        content: (
            <ul>
                <li>ಮೂರನೇ ವ್ಯಕ್ತಿ ಸೇವಾ ಪೂರೈಕೆದಾರರು: ಪಾವತಿ ಪ್ರಕ್ರಿಯೆ, ಲಾಜಿಸ್ಟಿಕ್ಸ್, ಮತ್ತು ವಿಶ್ಲೇಷಣೆಗಾಗಿ.</li>
                <li>ಕಾನೂನು ಅಧಿಕಾರಿಗಳು: ಕಾನೂನು ಅಥವಾ ಕಾನೂನು ವಿನಂತಿಗಳಿಗೆ ಪ್ರತಿಕ್ರಿಯೆಯಾಗಿ ಅಗತ್ಯವಿರುವಾಗ.</li>
                <li>ವ್ಯವಹಾರ ವರ್ಗಾವಣೆಗಳು: ವಿಲೀನ, ಸ್ವಾಧೀನ ಅಥವಾ ಆಸ್ತಿಗಳ ಮಾರಾಟದ ಸಂದರ್ಭದಲ್ಲಿ.</li>
            </ul>
        ),
    },
    {
        title: "ಕುಕೀಸ್ ಮತ್ತು ಟ್ರ್ಯಾಕಿಂಗ್ ತಂತ್ರಜ್ಞಾನಗಳು",
        content: (
            <ul>
                <li>ನಿಮ್ಮ ಆದ್ಯತೆಗಳನ್ನು ನೆನಪಿಡಿ.</li>
                <li>ವೆಬ್‌ಸೈಟ್ ಆಪ್ಟಿಮೈಸೇಶನ್‌ಗಾಗಿ ಬಳಕೆದಾರರ ನಡವಳಿಕೆಯನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ ಮತ್ತು ವಿಶ್ಲೇಷಿಸಿ.</li>
                <li>ವೈಯಕ್ತಿಕ ಶಿಫಾರಸುಗಳನ್ನು ಒದಗಿಸುವುದು.</li>
                <li>ನೀವು ನಿಮ್ಮ ಕುಕೀ ಆದ್ಯತೆಗಳನ್ನು ನಿಮ್ಮ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್ಗಳಲ್ಲಿ ನಿರ್ವಹಿಸಬಹುದು.</li>
            </ul>
        ),
    },
    {
        title: "ಸುರಕ್ಷಾ ಕ್ರಮಗಳು",
        content: (
            <ul>
                <li>ಪಾವತಿ ವಹಿವಾಟುಗಳಿಗೆ ಸುರಕ್ಷಿತ ಸಾಕೆಟ್ ಲೇಯರ್ (SSL) ಎನ್‌ಕ್ರಿಪ್ಶನ್.</li>
                <li>ನಿಯಮಿತ ಭದ್ರತಾ ಲೆಕ್ಕಪರಿಶೋಧನೆ ಮತ್ತು ನವೀಕರಣಗಳು.</li>
            </ul>
        ),
    },
    {
        title: "ಡೇಟಾ ಉಳಿಸಿಕೊಳ್ಳುವಿಕೆ",
        content: (
            <ul>
                <li>ವಿವರಿಸಿದ ಉದ್ದೇಶಗಳನ್ನು ಪೂರೈಸಲು ಅಗತ್ಯವಿರುವವರೆಗೆ ನಾವು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಉಳಿಸಿಕೊಳ್ಳುತ್ತೇವೆ.</li>
                <li>ಕಾನೂನು ಮತ್ತು ನಿಯಂತ್ರಕ ಕಟ್ಟುಪಾಡುಗಳನ್ನು ಪಾಲಿಸುವುದು.</li>
            </ul>
        ),
    },
    {
        title: "ನಿಮ್ಮ ಹಕ್ಕುಗಳು",
        content: (
            <ul>
                <li>ಪ್ರವೇಶ ಮತ್ತು ತಿದ್ದುಪಡಿ: ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಡೇಟಾಗೆ ಪ್ರವೇಶ ಅಥವಾ ತಿದ್ದುಪಡಿಯನ್ನು ವಿನಂತಿಸಿ.</li>
                <li>ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂಪಡೆಯಿರಿ: ಮಾರ್ಕೆಟಿಂಗ್ ಸಂವಹನಗಳು ಅಥವಾ ಸಂದೇಶಗಳಿಂದ ಹೊರಗುಳಿಯಿರಿ.</li>
                <li>ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಡಿಲೀಟ್ ಮಾಡಿ: ಕಾನೂನಾತ್ಮಕ ಮತ್ತು ಕಾರ್ಯಾಚರಣೆಯ ನಿರ್ಬಂಧಗಳಿಗೆ ಒಳಪಟ್ಟು ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಡಿಲೀಟ್ ಮಾಡಲು ಕೋರಿಕೆ ಸಲ್ಲಿಸಿ.</li>
            </ul>
        ),
    },
    {
        title: "ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಲಿಂಕ್‌ಗಳು",
        content: <p>ನಮ್ಮ ವೆಬ್‌ಸೈಟ್ ಬಾಹ್ಯ ವೆಬ್‌ಸೈಟ್‌ಗಳಿಗೆ ಲಿಂಕ್‌ಗಳನ್ನು ಹೊಂದಿರಬಹುದು. ಅವರ ಗೌಪ್ಯತಾ ಅಭ್ಯಾಸಗಳು ಅಥವಾ ವಿಷಯಕ್ಕೆ ನಾವು ಜವಾಬ್ದಾರರಲ್ಲ.</p>,
    },
    {
        title: "ಈ ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಬದಲಾವಣೆಗಳು",
        content: <p>ನಾವು ಈ ಗೌಪ್ಯತಾ ನೀತಿಯನ್ನು ನಿಯತಕಾಲಿಕವಾಗಿ ನವೀಕರಿಸಬಹುದು. ನವೀಕರಿಸಿದ ಪರಿಷ್ಕರಣೆ ದಿನಾಂಕದೊಂದಿಗೆ ಬದಲಾವಣೆಗಳನ್ನು ಈ ಪುಟದಲ್ಲಿ ಪೋಸ್ಟ್ ಮಾಡಲಾಗುತ್ತದೆ.</p>,
    },
    {
        title: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
        content: (
            <>
                <p>ಇಮೇಲ್: Support@terraclenz.com</p>
                <p>ದೂರವಾಣಿ: 7022519222</p>
            </>
        ),
    },
];
const policyContenta = [
    {
        title: "நாங்கள் சேகரிக்கும் தகவல்கள்",
        content: (
            <>
                <p>பின்வரும் வகையான தகவல்களை நாங்கள் சேகரிக்கிறோம்:</p>
                <ul>
                    <li><strong>தனிப்பட்ட தகவல்:</strong> பெயர், மின்னஞ்சல் முகவரி, தொலைபேசி எண், ஷிப்பிங் மற்றும் பில்லிங் முகவரிகள், கணக்கு விவரங்கள் (பயனர்பெயர், கடவுச்சொல்).
                    </li>
                    <li><strong>கட்டணத் தகவல்:</strong> கிரெடிட்/டெபிட் கார்டு விவரங்கள், UPI ஐடிகள், மூன்றாம் தரப்பு கட்டண நுழைவாயில்களால் பாதுகாப்பாக செயலாக்கப்படும்.
                    </li>
                    <li><strong>தனிப்பட்ட தகவல் அல்லாதவை:</strong> IP முகவரி, உலாவி வகை, இயக்க முறைமை, சாதன விவரங்கள்.</li>
                    <li><strong>குக்கீகள் & கண்காணிப்பு:</strong> குக்கீகள், வலை பீக்கான்கள் அல்லது பிற கண்காணிப்பு தொழில்நுட்பங்கள் மூலம் சேகரிக்கப்பட்ட தகவல்கள்.
                    </li>
                </ul>
            </>
        ),
    },
    {
        title: "உங்கள் தகவலை நாங்கள் எவ்வாறு பயன்படுத்துகிறோம்",
        content: (
            <ul>
                <li>உங்கள் ஆர்டர்களைச் செயல்படுத்தி வழங்குங்கள்.
                </li>
                <li>வாடிக்கையாளர் ஆதரவை வழங்கவும்.
                </li>
                <li>பயனர் அனுபவத்தை மேம்படுத்தி எங்கள் வலைத்தளத்தை மேம்படுத்தவும்.
                </li>
                <li>விளம்பரச் சலுகைகள், புதுப்பிப்புகள் மற்றும் சந்தைப்படுத்தல் தகவல்தொடர்புகளை (ஒப்புதலுடன்) அனுப்பவும்.
                </li>
                <li>சட்ட மற்றும் ஒழுங்குமுறை கடமைகளுக்கு இணங்குவதை உறுதி செய்யவும்.
                </li>
            </ul>
        ),
    },
    {
        title: "உங்கள் தகவல்களைப் பகிர்தல்",
        content: (
            <ul>
                <li>மூன்றாம் தரப்பு சேவை வழங்குநர்கள்: கட்டணச் செயலாக்கம், தளவாடங்கள் மற்றும் பகுப்பாய்வுகளுக்கு.
                </li>
                <li>சட்ட அதிகாரிகள்: சட்டத்தின்படி தேவைப்படும்போது அல்லது சட்ட கோரிக்கைகளுக்கு பதிலளிக்கும் விதமாக.
                </li>
                <li>வணிக பரிமாற்றங்கள்: சொத்துக்களின் இணைப்பு, கையகப்படுத்தல் அல்லது விற்பனையின் போது.
                </li>
            </ul>
        ),
    },
    {
        title: "குக்கீகள் மற்றும் கண்காணிப்பு தொழில்நுட்பங்கள்",
        content: (
            <ul>
                <li>உங்கள் விருப்பங்களை நினைவில் கொள்ளுங்கள்.
                </li>
                <li>வலைத்தள மேம்படுத்தலுக்காக பயனர் நடத்தையைக் கண்காணித்து பகுப்பாய்வு செய்யுங்கள்.
                </li>
                <li>தனிப்பயனாக்கப்பட்ட பரிந்துரைகளை வழங்கவும்.
                </li>
                <li>உங்கள் உலாவி அமைப்புகளில் உங்கள் குக்கீ விருப்பங்களை நிர்வகிக்கலாம்.
                </li>
            </ul>
        ),
    },
    {
        title: "பாதுகாப்பு நடவடிக்கைகள்",
        content: (
            <ul>
                <li>கட்டண பரிவர்த்தனைகளுக்கான பாதுகாப்பான சாக்கெட் லேயர் (SSL) குறியாக்கம்.
                </li>
                <li>வழக்கமான பாதுகாப்பு தணிக்கைகள் மற்றும் புதுப்பிப்புகள்.
                </li>
            </ul>
        ),
    },
    {
        title: "தரவு வைத்திருத்தல்",
        content: (
            <ul>
                <li>கோடிட்டுக் காட்டப்பட்ட நோக்கங்களை நிறைவேற்றுவதற்குத் தேவையான வரை உங்கள் தனிப்பட்ட தகவல்களை நாங்கள் தக்கவைத்துக்கொள்கிறோம்.
                </li>
                <li>சட்ட மற்றும் ஒழுங்குமுறை கடமைகளுக்கு இணங்குதல்.
                </li>
            </ul>
        ),
    },
    {
        title: "உங்கள் உரிமைகள்",
        content: (
            <ul>
                <li>அணுகல் மற்றும் திருத்தம்: உங்கள் தனிப்பட்ட தரவை அணுக அல்லது திருத்தக் கோருங்கள்.
                </li>
                <li>ஒப்புதலைத் திரும்பப் பெறுதல்: சந்தைப்படுத்தல் தகவல்தொடர்புகளிலிருந்து விலகுதல்.
                </li>
                <li>உங்கள் தரவை நீக்கு: சட்ட மற்றும் செயல்பாட்டு கட்டுப்பாடுகளுக்கு உட்பட்டு, உங்கள் தரவை நீக்கக் கோருங்கள்.
                </li>
            </ul>
        ),
    },
    {
        title: "மூன்றாம் தரப்பு இணைப்புகள்",
        content: <p>எங்கள் வலைத்தளம் வெளிப்புற வலைத்தளங்களுக்கான இணைப்புகளைக் கொண்டிருக்கலாம். அவற்றின் தனியுரிமை நடைமுறைகள் அல்லது உள்ளடக்கத்திற்கு நாங்கள் பொறுப்பல்ல.</p>,
    },
    {
        title: "இந்த தனியுரிமைக் கொள்கையில் மாற்றங்கள்",
        content: <p>இந்த தனியுரிமைக் கொள்கையை நாங்கள் அவ்வப்போது புதுப்பிக்கலாம். புதுப்பிக்கப்பட்ட திருத்த தேதியுடன் மாற்றங்கள் இந்தப் பக்கத்தில் இடுகையிடப்படும்.</p>,
    },
    {
        title: "எங்களை தொடர்பு கொள்ள",
        content: (
            <>
                <p>மின்னஞ்சல்: Support@terraclenz.com
                </p>
                <p>தொலைபேசி: 7022519222</p>
            </>
        ),
    },
];
const pbhi ={
	"1": "गोपनीयता नीति",
	"2": "होम",
	"3": "TERRACLENZ (\"हम,\" \"हमारा,\" या \"हम\") आपके द्वारा हम पर किए गए विश्वास को महत्व देता है और आपकी व्यक्तिगत और संवेदनशील जानकारी की सुरक्षा के लिए प्रतिबद्ध है।"
};
const pben ={
	"1": "Privacy Policy",
	"2": "Home",
	"3": "TERRACLENZ (\"we,\" \"our,\" or \"us\") values the trust you place in us and is committed to protecting your personal and sensitive information."
}
const pbka ={
	"1": "ಗೌಪ್ಯತೆ ನೀತಿ",
	"2": "ಮರಳಿ ಪ್ರಥಮ ಪುಟಕ್ಕೆ",
	"3": "ಟೆರಾಕ್ಲೆನ್ಜ್ (\"ನಾವು,\" \"ನಮ್ಮ,\" ಅಥವಾ \"ನಮಗೆ\") ನೀವು ನಮ್ಮ ಮೇಲೆ ಇಟ್ಟಿರುವ ನಂಬಿಕೆಯನ್ನು ಗೌರವಿಸುತ್ತೇವೆ ಮತ್ತು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮತ್ತು ಸೂಕ್ಷ್ಮ ಮಾಹಿತಿಯನ್ನು ರಕ್ಷಿಸಲು ಬದ್ಧರಾಗಿದ್ದೇವೆ."
}
const pbte ={
	"1": "గోప్యతా విధానం",
	"2": "హోం",
	"3": "టెర్రాక్లెన్జ్ (\"మేము,\" \"మా,\" లేదా \"మాకు\") మీరు మాపై ఉంచిన నమ్మకాన్ని గౌరవిస్తాం మరియు మీ వ్యక్తిగత మరియు సున్నితమైన సమాచారాన్ని రక్షించడానికి కట్టుబడి ఉంటాము."
}
const pbta ={
	"1": "முகப்புப் பக்கம்",
	"2": "தனியுரிமைக் கொள்கை",
	"3": "டெர்ராகிளென்ஸ் (நாங்கள் எங்கள் அல்லது எங்கள்) நீங்கள் எங்கள் மீது வைத்திருக்கும் நம்பிக்கையை மதிக்கிறது மற்றும் உங்கள் தனிப்பட்ட மற்றும் முக்கியமான தகவல்களைப் பாதுகாப்பதில் உறுதியாக உள்ளது"
}
const [pb, setPB] = useState(pben)
const [policyContent, setHomeen] = useState(policyContente)

useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
switch (storedLanguage) {
    case "kn":
        setHomeen(policyContentka);
        setPB(pbka);
        break;
    case "te":
        setHomeen(policyContentte);
        setPB(pbte);
        break;
    case "ta":
        setHomeen(policyContenta);
        setPB(pbta);
        break;
        case "hi":
        setHomeen(policyContenhi);
        setPB(pbhi);
        break;
    default:
            setHomeen(policyContente);
            setPB(pben);
}

}, []);
    return (
        <>
            <div className="breadcrumb-wrap bg-f br-2">
                <div className="container">
                    <div className="breadcrumb-title">
                        <h2>{pb["1"]}</h2>
                        <ul className="breadcrumb-menu list-style">
                            <li><Link to="/">{pb["2"]}</Link></li>
                            <li>{pb["1"]}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="faqs-container">
                <div>
                    <p class="inlinehere">{pb["3"].split(" ")[0]}<span class="here" style={{color:"black"}}>TM</span>{pb["3"].split(" ").slice(1).join(" ")}</p>
                </div>
                <hr />
                <div>
                    {policyContent.map((section, index) => (
                        <div className="faq" key={index}>
                            <h6 onClick={() => toggleFAQ(index)} className="faq-question">
                                {section.title} {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                            </h6>
                            <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
                                {openIndex === index && section.content}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Privacy_policy;
